// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__4tEVG","rootSmall":"AddTileButton_rootSmall__1V944"};